import React from 'react';
import { Slider, Direction } from 'react-player-controls';

const ProgressBar = ({ isEnabled, direction, value, ...props }) => {
  const WHITE_SMOKE = '#eee';
  const GRAY = '#878c88';

  return (
    <>
      <Slider
        isEnabled
        direction={Direction.HORIZONTAL}
        style={{
          width: '100%',
          height: 18,
          borderRadius: 4,
          background: WHITE_SMOKE,
          transition:
            direction === Direction.HORIZONTAL ? 'width 0.1s' : 'height 0.1s',
        }}
        {...props}
      >
        <div
          style={Object.assign(
            {},
            {
              position: 'absolute',
              background: GRAY,
              borderRadius: 4,
            },
            {
              top: 0,
              bottom: 0,
              left: 0,
              width: `${value * 100}%`,
              background: '#c10f3a',
            }
          )}
        />
      </Slider>
      ;
    </>
  );
};

export default ProgressBar;
